var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#112299"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.509 14C10.0681 14 9.71076 13.6426 9.71076 13.2018V10.7414H7.24138C6.83193 10.7414 6.5 10.4095 6.5 10C6.5 9.59055 6.83193 9.25862 7.24138 9.25862H9.71076V6.79821C9.71076 6.35737 10.0681 6 10.509 6C10.9498 6 11.3072 6.35737 11.3072 6.79821V9.25862H13.7586C14.1681 9.25862 14.5 9.59055 14.5 10C14.5 10.4095 14.1681 10.7414 13.7586 10.7414H11.3072V13.2018C11.3072 13.6426 10.9498 14 10.509 14Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSection);
export default __webpack_public_path__ + "static/media/addSection.7e32b208bddb01883efb388ffe5f6d41.svg";
export { ForwardRef as ReactComponent };